import { CobaltBreadcrumb } from '@cae/cobalt-react/components/breadcrumb';
import { CobaltButton } from '@cae/cobalt-react/components/button';
import { EmailExistsIllustration } from '@features/register-user/components/illustrations/EmailExistsIllustration';
import * as React from 'react';

import type { EmailExistsProps } from './EmailExists.types';

import styles from './EmailExists.module.css';

const EmailExists = React.memo(
  ({
    onLoginClick,
    onResetPassword,
    onBackClick,
  }: Readonly<EmailExistsProps>): React.ReactElement => {
    return (
      <div className={styles.emailExists} data-testid="email-exists">
        <CobaltBreadcrumb
          aria-label="Back"
          variant="back-navigation"
          onBackClick={onBackClick}
          className={styles.breadcrumb}
        >
          Back
        </CobaltBreadcrumb>
        <EmailExistsIllustration />
        <span className={styles.message}>
          It looks like an account with this email has already been registered.
        </span>
        <CobaltButton
          type="button"
          variant="primary"
          className={styles.signInButton}
          onClick={onLoginClick}
        >
          Sign in here
        </CobaltButton>
        <div className={styles.divider}>
          <span className={styles.dividerText}>or</span>
        </div>
        <CobaltButton type="button" variant="ghost" onClick={onResetPassword}>
          Reset password
        </CobaltButton>
      </div>
    );
  }
);

EmailExists.displayName = 'EmailExists';

export { EmailExists };
